import React from 'react';
import { showReportDialog } from '@sentry/react';
import Button from '@storeblocks/button';
import { getText } from '@storebrand-digital/fms-translations';
import { ButtonWrap, Wrap } from './styled';
function ErrorBoundary() {
    return (React.createElement(Wrap, null,
        React.createElement("h1", null, getText('error.unhandled.title')),
        React.createElement(ButtonWrap, null,
            React.createElement(Button, { onClick: function () { return showReportDialog(); } }, getText('error.unhandled.feedback')))));
}
export default ErrorBoundary;
